// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-fee-tab-custom-tooltip>.tooltip-inner{max-width:800px;text-align:justify;font-size:14px}", ""]);
// Exports
module.exports = exports;
